<template>
    <q-layout view="hHh lpR fFf">
        <q-header  v-if="logueado">
            <q-toolbar style="min-height:60px">
                <q-btn flat dense round @click="irInicio" style="background:rgba(255,255,255,.12)">
                    <q-icon name="mdi-home" color="white" size="23px" />
                </q-btn>
                <q-toolbar-title>
                    <span style="font-size:16px;font-weight:500;letter-spacing:.01em">
                        AUTOCONTA   
                        </span>
                    </q-toolbar-title>
                <div class="rfc-chip" style="font-size:16px;">{{ $store.state.usuario.rfc }}</div>

                <q-btn flat round dense class="header-btn" @click="drawerEmpresas = !drawerEmpresas">
                    <q-icon name="mdi-domain" color="white" size="23px" />
                    <q-tooltip content-style="font-size:13px">Empresas</q-tooltip>
                </q-btn>

                <q-btn flat round dense class="header-btn" @click="drawerPerfil = !drawerPerfil">
                    <q-icon name="mdi-account" color="white" size="23px" />
                    <q-tooltip content-style="font-size:13px">Perfil</q-tooltip>
                </q-btn>
            </q-toolbar>
        </q-header>
        
     <!-- DRAWER DERECHO -->
     <q-drawer :width="320" v-model="drawerPerfil" behavior="mobile" side="right" bordered v-if="logueado"
            style="background:#fff">
            <drawerPerfil />
        </q-drawer>
        

         <!-- DRAWER EMPRESAS -->
    <q-drawer :width="320" v-model="drawerEmpresas" behavior="mobile" side="right" bordered v-if="logueado"
                style="background:#fff">
                <drawerEmpresas />
            </q-drawer>

        <q-drawer v-model="leftDrawerOpen" show-if-above :mini="miniState" @mouseover="miniState = false"
            @mouseout="miniState = true" :width="320" :breakpoint="500" bordered content-class="bg-purple-1">
            <q-scroll-area class="fit" :horizontal-thumb-style="{ opacity: 0 }">
                <q-list padding>

                    <q-item active clickable v-ripple @click="irCentrosDeCostos">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-scale-balance" />
                        </q-item-section>
                        <q-item-section>
                            {{ $t('centroCostos.sidebar.main') }}
                        </q-item-section>
                    </q-item>
                    <q-separator />

                    <q-item active clickable v-ripple @click="irPolizas">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-scale-balance" />
                        </q-item-section>
                        <q-item-section>
                            {{ $t('centroCostos.sidebar.reconcile') }}
                        </q-item-section>
                    </q-item>
                    <q-separator />
                    <q-item active clickable v-ripple @click="irBalanza">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-scale-balance" />
                        </q-item-section>
                        <q-item-section>
                            {{ $t('centroCostos.sidebar.trialBalance') }}
                        </q-item-section>
                    </q-item>
                    <q-separator />
                    <q-item active clickable v-ripple @click="irEstadoR">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-file-chart" />
                        </q-item-section>
                        <q-item-section>
                            {{ $t('centroCostos.sidebar.incomeStatement') }}
                        </q-item-section>
                    </q-item>
                    <q-separator />
                    <q-item active clickable v-ripple @click="irEstadoS">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-file-chart" />
                        </q-item-section>
                        <q-item-section>
                            {{ $t('centroCostos.sidebar.balanceSheet') }}
                        </q-item-section>
                    </q-item>
                    <q-separator />
                    <q-item active clickable v-ripple @click="irVentasCxC">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-trending-up" />
                        </q-item-section>
                        <q-item-section>
                            {{ $t('centroCostos.sidebar.sales') }}
                        </q-item-section>
                    </q-item>
                    <q-separator />
                    <q-item active clickable v-ripple @click="irComprasCxC">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-trending-down" />
                        </q-item-section>
                        <q-item-section>
                            {{ $t('centroCostos.sidebar.purchases') }}
                        </q-item-section>
                    </q-item>
                    <q-separator />
                </q-list>
            </q-scroll-area>
        </q-drawer>

        <q-page-container>
            <router-view />
        </q-page-container>
    </q-layout>
</template>

<script>
import { ref } from 'vue'
import axios from "axios";
import drawerEmpresas from '../DrawerEmpresas/DrawerEmpresas.vue'
import drawerPerfil from "../DrawerPerfil/DrawerPerfil.vue"

export default {
    name: 'MainLayout',
    components: {
        drawerPerfil, drawerEmpresas
    },
    data() {
        return {
            drawerPerfil: false,
            isDarkMode: false,
            leftDrawerOpen: false,
            drawer: false,
            miniState: true,
            drawerEmpresas: false,

        }
    },
    watch: {
        isDarkMode(val) {
            this.$q.dark.set(val);
        }
    },
    computed: {
        token() {
            return this.$store.state.usuario;
        },
        logueado() {
            return this.$store.state.usuario;
        },
    },
    created() {
    },
    methods: {
        irCentrosDeCostos() {
            this.$router.push({ name: 'ListCentroCostos' })
        },
        irPolizas() {
            this.$router.push({ name: 'ListPolizasCentroCostos' })
        },
        irBalanza(){
            this.$router.push({ name: 'ListaBalanzaCC' })
        },
        irEstadoR(){
            this.$router.push({ name: 'EstadoResultadosCC' })
        },
        irEstadoS(){
            this.$router.push({ name: 'EstadoSituacionFinancieraCC' })
        },
        irVentasCxC(){
            this.$router.push({ name: 'VentasCxC' })
        },
        irComprasCxC(){
            this.$router.push({ name: 'ComprasCxC' })
        },
        irInicio() {
            this.$router.push({ name: 'Home' })
        }
    }
}
</script>